<template>
    <div class="card">
        <div class="card-body" v-if="hasReadRights">
            <div class="loader" v-if="loading"></div>
            <div v-else class="m-3" v-html="infoData"></div>
        </div>
    </div>
</template>

<script>
    import personalizationService from '../../services/personalization.service';

    export default {
        data() {
            return {
                loading: false,
                infoData: '',
            };
        },
        methods: {
            loadReleaseInfo() {
                this.loading = true;
                personalizationService
                    .loadReleaseInfo()
                    .then(response => {
                        this.loading = false;
                        if (response.data) {
                            this.infoData = response.data
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                    });
            },
        },
        mounted() {
            this.loadReleaseInfo();
        },
        computed: {
            hasReadRights() {
                return this.$store.getters.claims.releaseInfo.read;
            },
        },
    };
</script>

<style>
</style>
